module.exports = __webpack_public_path__ + "static/media/goals-and-targets-share-price.90d74854.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/goals-and-targets-share-price.mp4
// module id = 564
// module chunks = 0